import graphql from 'babel-plugin-relay/macro';

export const mobilePlanCardsProductsQuery = graphql`
  query MobilePlanCardsProductsQuery(
    $categoryId: String!
    $channel: String!
    $includeCompanions: Boolean
  ) {
    eligibleProductOffersByCategory(
      categoryId: $categoryId
      channel: $channel
      includeCompanions: $includeCompanions
    ) {
      code
      message
      category {
        id
        name
        description
        promotions {
          name
          longDescription
          productType
          infoUrl
        }
        plans {
          planDetails {
            planId
            description
            planName
            contentKey
            isTeamUpEligible
            categoryIdentifiers
            productType
          }
          price {
            priceType
            pricePeriod
            priceFrequency
            basePrice
            basePriceExcludingTax
          }
          contractTerm {
            name
          }
          entitlements {
            name
            shortDescription
            longDescription
            quantity
            iconUrl
            sortOrder
            contentKey
          }
          planImages {
            description
            sortOrder
            defaultUrl
            zoomUrl
            standardUrl
            thumbnailUrl
            tinyUrl
            type
          }
          group {
            id
            name
          }
          promotions {
            name
            shortDescription
            longDescription
            productType
            sortOrder
            contentKey
            iconUrl
          }
          productCharacteristics {
            balanceManagement
            offerEligibilityLevel
            relatedOfferId
            relatedOfferIds
          }
          ctaOverrides {
            type
            label
            segment
            data
            sortOrder
            style
          }
          dataLayerCategory
        }
      }
    }
  }
`;
